var _rect, _rect2, _rect3, _rect4, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealsTickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 127,
    viewBox: "0 0 143 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 32,
    width: 15,
    height: 61,
    rx: 7.5,
    fill: "#8CCE56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 16,
    width: 14,
    height: 77,
    rx: 7,
    fill: "#DF8383"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 52,
    width: 15,
    height: 41,
    rx: 7.5,
    fill: "#8CCE56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 32,
    width: 14,
    height: 61,
    rx: 7,
    fill: "#2EA9A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11V86C26 102.569 39.4315 116 56 116H127",
    stroke: "url(#paint0_linear_61_14)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_14",
    x1: 19.9153,
    y1: 11,
    x2: 19.9153,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81C34C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsTickerIcon);
export default __webpack_public_path__ + "static/media/deals_ticker_icon.c846840aaa704623cd995be0a50d5824.svg";
export { ForwardRef as ReactComponent };